/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import * as actionTypes from './ActionTypes';

export const setLoadInitialFlag = (data) => {
  return {
    type: actionTypes.SET_LOAD_INITIAL_FLAG,
    payload: data,
  };
};
export const clearSuspend = () => ({
  type: actionTypes.CLEAR_NP_SUSPENDED,
});

export const setPostInitRes = (data) => {
  return {
    type: actionTypes.GET_POST_INIT_BY_MIR,
    payload: data,
  };
};

export const deallocateNdcPqasStore = (val) => {
  return { type: actionTypes.DEALLOCATE_NDC_PQAS, payload: val };
};

export const updateIdsDealloc = (val) => {
  return { type: actionTypes.ID_DEALLOC_PQAS, payload: val };
};

export const getPostInitByMIR = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_POST_INIT_BY_MIR, payload)
    .then((response) => {
      dispatch(setPostInitRes(response?.data?.postInitByMirResp));
      return response?.data?.postInitByMirResp
        ? response.data.postInitByMirResp
        : [];
    })
    .catch(() => {
      return dispatch(setPostInitRes([]));
    });
};
export const dispatchIsColumnDone = (data) => {
  return {
    type: actionTypes.ALLOCATE_PAYMENTS_2_IS_COLUMN_DONE,
    payload: data,
  };
};
export const dispatchGetInvoiceHeader = (data) => {
  return {
    type: actionTypes.ALLOCATE_PAYMENTS_2_INVOICEHEADER,
    payload: data,
  };
};
export const dispatchIbOpening = (data) => {
  return {
    type: actionTypes.ALLOCATE_PAYMENTS_2_IB_OPENING,
    payload: data,
  };
};
export const dispatchGetDeletedRow = (data) => {
  return {
    type: actionTypes.GET_DELETED_ROW,
    payload: data,
  };
};

export const getInvoiceHeader = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.ALLOCATE_PAYMENTS_GETINVOICEHEADER, payload)
    .then((response) => {
      return dispatch(dispatchGetInvoiceHeader(response.data));
    })
    .catch((response) => {
      return dispatch(dispatchGetInvoiceHeader(response.data));
    });
};

export const dispatchGetPqasGridAp2 = (data) => {
  if (data?.headerData) {
    return {
      type: actionTypes.GET_PQASGRID_AP2,
      payload: data.list,
      headerData: data.headerData,
      isUpdateData: data.isUpdateData,
      onloadData: data.onloadData,
    };
  }
};

export const getPqasGridAp2 = (payload) => (dispatch, getState) => {
  const Obj =
    getState()?.sharedState.AllocatePaymentReducer?.headerAllocatePaymentData[
      `${payload?.idecInvoiceNum}-${payload?.checkLogNum}`
    ];
  const fetchAllDetailScreenData =
    getState()?.sharedState.AllocatePaymentReducer2?.detailScreenObj;
  const temp = _.cloneDeep(fetchAllDetailScreenData);
  delete payload.checkLogNum;

  temp[`${Obj?.invoiceNum}-${Obj?.checkLogNum}`] = {
    ...temp[`${Obj?.invoiceNum}-${Obj?.checkLogNum}`],
    // rowIndex: 0,
    isShowRow: true,
    defaultRow: true,
  };
  return axios
    .post(serviceEndPoint.ALLOCATE_PAYMENTS2_GET_PQASGRID, payload)
    .then((response) => {
      let list = [];
      dispatch(
        dispatchGetPqasGridAp2({
          list: [],
          headerData: Obj,
          isUpdateData: true,
        })
      );
      if (response && response.data) {
        if (
          response.data.message === 'SUCESS' &&
          response.data.status === '001'
        ) {
          list = response.data?.dwpqasGridRes;
        }
      }
      dispatch(setAllocatePaymentDetailTabData(temp));
      const tempObj1 = list?.map((item) => {
        item.id = uuidv4();
        item.orgPaidThisTransactionAmt = item.paidThisTransactionAmt;
        return item;
      });
      return dispatch(
        dispatchGetPqasGridAp2({
          list: tempObj1,
          headerData: Obj,
          isUpdateData: true,
          onloadData: tempObj1,
        })
      );
    })
    .catch(() => {
      dispatch(setAllocatePaymentDetailTabData(temp));
      return { error: 'API Failed' };
    });
};

export const dispatchGetPqasDrugsFullyPartially = (data) => {
  return {
    type: actionTypes.PQAS_DRUGS_PAID_FULLY_OR_PARTIALLY,
    payload: data,
  };
};

export const getPqasDrugsFullyPartially = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PQAS_DRUGS_PAID_FULLY_OR_PARTIALLY, payload)
    .then((response) => {
      const tempFullyObj =
        response?.data?.pqasdrugsPaidFullyOrPartiallyResponseVo.map((item) => {
          item.orgPaidThisTransactionAmt = item.paidThisTransactionAmt;
          return item;
        });
      return dispatch(dispatchGetPqasDrugsFullyPartially(tempFullyObj));
    })
    .catch((response) => {
      return dispatch(dispatchGetPqasDrugsFullyPartially([]));
    });
};

// get adj code & dispute code
export const dispatchGetAdjDisputeCodes = (data) => {
  return {
    type: actionTypes.ADJ_DISPUTE_CODES,
    payload: data,
  };
};

export const getAdjDisputeCodes = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ADJUST_DISPUTE_DETAILS, payload)
    .then((response) => {
      let list = [];
      if (response && response.data) {
        if (
          response.data.message === 'SUCESS' &&
          response.data.status === '001'
        ) {
          list = response.data.data;
        }
      }
      return dispatch(dispatchGetAdjDisputeCodes(list));
    })
    .catch((response) => {
      return dispatch(dispatchGetAdjDisputeCodes([]));
    });
};

// get PQAS DrugsPaid TransactionAmt

export const dispatchPQASDrugsPaidTrnsctionAmt = (data) => {
  return {
    type: actionTypes.PQAS_DRUGS_PAID_TRANSACTION_AMT,
    payload: data,
  };
};

export const getPQASDrugsPaidTrnsctionAmt = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PQASDRUGS_PAID_TRANSACTION_AMT, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};
// get pqas summary grid data list
export const dispatchGetSummaryGridList = (
  data,
  invNum,
  checkLogNum,
  isUpdateData
) => {
  return {
    type: actionTypes.GET_PQAS_SUMMARY_GRID,
    summaryGridList: data,
    invoiceNum: invNum,
    checkLogNum: checkLogNum,
    isUpdateData: isUpdateData,
  };
};

export const getPQASSummayGridList =
  (
    payload,
    cfSumOwedAmt,
    totalPrincipalPaid,
    principalPaidThisCheck,
    prevIntPaidAmt = 0
  ) =>
  (dispatch) => {
    return axios
      .post(serviceEndPoint.GET_PQAS_SUMMARY_GRID, payload)
      .then((response) => {
        let list = [];
        if (response && response.data) {
          if (
            response.data.message === 'SUCESS' &&
            response.data.status === '001'
          ) {
            const newObj = response.data?.summaryGridResp;
            if (cfSumOwedAmt) {
              newObj[0].cfSumOwedAmt = cfSumOwedAmt;
              newObj[0].currentPrincipalAmt = cfSumOwedAmt;
              newObj[0].totalPrincipalPaid = totalPrincipalPaid;
              newObj[0].principalPaidThisCheck = principalPaidThisCheck;
              newObj[0].orgPrincipalPaidThisCheck = principalPaidThisCheck;
              newObj[0].orgIntPaidThisCheck = newObj[0].intPaidThisCheck;
              newObj[0].orgTotalIntPaid = newObj[0].totalIntPaid;
              newObj[0].intPaidThisCheck =
                parseFloat(prevIntPaidAmt) +
                parseFloat(newObj[0]?.intPaidThisCheck);
            }
            list = {
              [`${payload.idecInvoiceNum}-${payload.checkLogNum}`]: newObj || [
                {},
              ],
            };
          }
        }
        return dispatch(
          dispatchGetSummaryGridList(
            _.cloneDeep(list),
            payload.idecInvoiceNum,
            payload.checkLogNum,
            true
          )
        );
      })
      .catch((response) => {
        const list = {
          [`${payload.idecInvoiceNum}-${payload.checkLogNum}`]: [{}],
        };
        return dispatch(
          dispatchGetSummaryGridList(
            list,
            payload.idecInvoiceNum,
            payload.checkLogNum,
            true
          )
        );
      });
  };
// get unit rebate amount from DQD

export const dispatchGetUraFromDqd = (data) => {
  return {
    type: actionTypes.URA_FROM_DQD,
    payload: data?.data,
  };
};

export const getUraFromDqd = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_URA_FROM_DQD, payload)
    .then((response) => {
      dispatch(dispatchGetUraFromDqd(response));
      return response?.data;
    })
    .catch((response) => {
      return dispatch(dispatchGetUraFromDqd([]));
    });
};

export const getUraFromDqdList = (payload) => () => {
  return axios
    .post(serviceEndPoint.GET_URA_FROM_DQD, payload)
    .then((response) => {
      let list = [];
      if (
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        list = response.data.data;
      }
      return list;
    })
    .catch(() => {
      return [];
    });
};

// For All table Grid level Actions
export const dispatchPQASGridLevelActions = (values) => {
  return {
    type: actionTypes.PQAS_TG_ACTIONS,
    payload: values,
  };
};
export const setAllocatePaymentDetailTabData = (data) => {
  return {
    type: actionTypes.PQRS_ALLOCATE_PAYMENT_DETAIL_SCREEN,
    detailScreenObj: data,
  };
};

// Get current invoice drug data
export const getCurrentInvoiceDrugs = (value) => () => {
  return axios
    .post(serviceEndPoint.GET_CURR_INVOICE_DRUG_DETAIL, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

// Get PQAS drug info data
export const getPqasDrugInfoForDrugs = (value) => () => {
  return axios
    .post(serviceEndPoint.GET_PQAS_DRUG_INFO, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

// Get ROSI drug info data
export const getRosiDrugInfoForDrugs = (value) => () => {
  return axios
    .post(serviceEndPoint.GET_ROSI_DRUG_INFO, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

// Get URA Data
export const getURAData = (value) => () => {
  return axios
    .post(serviceEndPoint.GET_URA_FROM_DQD, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

export const setSumAmtRes = (data) => {
  return {
    type: actionTypes.SUM_ORG_PAID_AMT,
    payload: data,
  };
};

export const getSumOrgPaidAmt = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SUM_ORG_PAID_AMT, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // dispatch(setSumAmtRes([]));
      return error;
    });
};

export const setPriorCurrUnitRes = (data) => {
  return {
    type: actionTypes.PRIOR_CURRENT_UNITS_RESPONSE,
    payload: data,
  };
};

export const getPriorCurrUnits = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PRIOR_CURR_UNITS, payload)
    .then((response) => {
      // dispatch(setPriorCurrUnitRes(response.data));
      return response.data;
    })
    .catch(() => {
      // dispatch(setPriorCurrUnitRes([]));
      return [];
    });
};

// ALLOCATE PAYMENTS PART 3
// NO pay suspended (Allacate payment part3)
export const noPaySuspended = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.NO_PAY_SUSPENDED, payload)
    .then((response) => {
      return dispatch(dispatchNoPaySuspended(response));
    })
    .catch((response) => {
      return dispatch(dispatchNoPaySuspended([]));
    });
};
export const dispatchNoPaySuspended = (data) => {
  return {
    type: actionTypes.NP_SUSPENDED,
    payload: data?.data,
  };
};
export const saveAllocatePaymentDetails = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_ALLOCATE_DETAILS, payload)
    .then((response) => {
      dispatch(dispatchSaveDetailsResponse(response));
      return response;
    })
    .catch((response) => {
      return dispatch(dispatchSaveDetailsResponse([]));
    });
};
export const dispatchSaveDetailsResponse = (data) => {
  return {
    type: actionTypes.SAVE_DETAILS,
    payload: data,
  };
};

export const dispatchColIdForPqas = (data) => ({
  type: actionTypes.CURR_COL_ID,
  payload: data,
});
// RECALC ACTION
// dispatch function

export const dispatchRecalValuesForPqas = (data) => ({
  type: actionTypes.GET_RECALC_VALUES_FOR_PQAS,
  payload: data,
});

export const getRecalValuesForPqas = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_RECALC_VALUES_FOR_PQAS_CALL, value)
    .then((response) => {
      dispatch(dispatchRecalValuesForPqas(response.data));
      return response.data;
    })
    .catch(() => {
      dispatch(dispatchRecalValuesForPqas({}));
    });
};

export const dispatchSetPaidAllocatedAmt = (data) => ({
  type: actionTypes.SET_PAID_ALLOCATED_AMT,
  payload: data,
});

export const updatePrevNextQtrForPQAS = (data) => ({
  type: actionTypes.UPDATE_PQAS_PREV_NEXT_QTR,
  payload: data,
});

export const setIsCanceling = (data) => ({
  type: actionTypes.SET_IS_CANCELING,
  payload: data,
});

export const setPaidAllocatedAmt = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SET_PAID_ALLOCATED_AMT, value)
    .then((response) => {
      dispatch(dispatchSetPaidAllocatedAmt(response.data));
      return response.data;
    })
    .catch(() => {
      dispatch(dispatchSetPaidAllocatedAmt({}));
    });
};

export const getPrevNextQtrForPQAS = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PQAS_PREV_NEXT_QTR, value)
    .then((response) => {
      let qtrVal = null;
      if (
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        qtrVal = response.data.qtr;
        dispatch(updatePrevNextQtrForPQAS(qtrVal));
      }
      return qtrVal;
    })
    .catch(() => {
      return null;
    });
};

// row without units amount API function
export const rowWithoutUnitsAmt = (payload) => () => {
  return axios
    .post(serviceEndPoint.GET_ROW_WITHOUT_UNITS_AMTS, payload)
    .then((response) => {
      const rowWithoutUnitsAmtData =
        response?.data?.rowWithoutUnitsAmtsResponseVOs;
      return true;
    })
    .catch(() => {
      return false;
    });
};

export const updatePqasGrid = (data) => {
  return {
    type: actionTypes.UPDATE_PQAS_GRID,
    payload: data,
  };
};

// Update current URA column

export const dispatchGetIdcCurrUra = (data) => {
  return {
    type: actionTypes.IDC_CURR_URA,
    payload: data?.data,
  };
};

export const getIdcCurrUra = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_IDC_CURR_URA, payload)
    .then((response) => {
      return dispatch(dispatchGetIdcCurrUra(response));
    })
    .catch((response) => {
      return dispatch(dispatchGetIdcCurrUra([]));
    });
};

export const deallocateNDCStore = (value) => {
  return { type: actionTypes.DEALLOCATE_NDC_PQAS, payload: value };
};

export const updateIstrDealloc = (value) => {
  return { type: actionTypes.ISTR_DEALLOC_DATA, payload: value };
};

export const getDeallocateNDC = (value) => () => {
  return axios
    .post(serviceEndPoint.DEALLOCATE_NDC, value)
    .then((response) => {
      return response?.data;
    })
    .catch(() => {
      return [];
    });
};

export const dispatchGetPreInitData = (value) => {
  return { type: actionTypes.SET_PRE_INIT_DATA, payload: value };
};
export const addOrDuplicateNDCPQASObjData = (data) => {
  return {
    type: actionTypes.ADD_OR_DUPLICATE_NDC_PQAS,
    addOrDuplicateNDCPQASObj: data,
  };
};
export const setDisabledValIntPaidPQAS = (data) => {
  return {
    type: actionTypes.DISABLED_INT_PAID_COLUMN_PQAS,
    disabledIntPaidColObj: data,
  };
};
export const getPreInitialiseData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PRE_INITIALISE_DATA, value)
    .then((response) => {
      dispatch(
        dispatchGetPreInitData(response?.data?.pqasPreInitializationResponseVo)
      );
      return response?.data?.pqasPreInitializationResponseVo;
    })
    .catch(() => {
      return dispatch(dispatchGetPreInitData({}));
    });
};
export const getPQASTabDiscrepanciesList = (value) => () => {
  console.time('pqasDiscLOGIC');
  const tempObj = { ...value };
  if (tempObj && tempObj?.pqasGridReqVo?.length > 0) {
    tempObj.pqasGridReqVo = tempObj?.pqasGridReqVo?.map((item) => {
      if (
        item.currUnitsDisputed === null ||
        item.currUnitsDisputed === '' ||
        isNaN(item.currUnitsDisputed) ||
        parseFloat(item.currUnitsDisputed)?.toString() === '0'
      ) {
        return { ...item, currUnitsDisputed: null };
      }

      return item;
    });
    console.timeEnd('pqasDiscLOGIC');
    console.time('pqasDISCAPI');
    return axios
      .post(serviceEndPoint.GET_DISCREPANCY_PQAS_TAB_LIST, tempObj)
      .then((response) => {
        console.timeEnd('pqasDISCAPI');
        return response?.data;
      })
      .catch(() => {
        return [];
      });
  }
};
export const setDuplicateDataPQASGrid = (data) => {
  return {
    type: actionTypes.DUPLICATE_PQAS_GRID,
    payload: data,
  };
};

export const setDuplicatePqasInterestIndex = (data) => ({
  type: actionTypes.SET_DUPLICATE_PQAS_INTEREST_INDEX,
  payload: data,
});
export const setOnLoadPQASGridError = (data) => {
  return {
    type: actionTypes.LOAD_PQAS_GRID_ERROR,
    loadPQASGridErrorObj: data,
  };
};
